'use client';


// ----------------------------------------------------------------------

const platforms = [
  {
    id: 'threads',
    label: 'Threads',
    icon: 'T',
    color: '#000000',
    default: true,
  },
  {
    id: 'x',
    label: 'X',
    icon: 'X',
    color: '#000000',
    default: true,
  },
  {
    id: 'instagram',
    label: 'Instagram',
    icon: 'I',
    color: '#E1306C',
    default: true
  },
  {
    id: 'youtube',
    label: 'Youtube',
    icon: 'Y',
    color: '#FF0099',
    default: false
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    icon: 'T',
    color: '#000000',
    default: false
  },
  {
    id: 'reddit',
    label: 'Reddit',
    icon: 'R',
    color: '#FF4500',
    default: false,
    account: 'reddit'
  },
  // {
  //   id: 'instiz',
  //   label: 'Instiz',
  //   icon: 'I',
  //   color: '#03C75A',
  //   author: '인스티즈',
  //   site: 'instiz.net',
  //   default: true,
  // },
  {
    id: 'dcinside',
    label: 'DC',
    icon: 'D',
    color: '#29367C',
    default: true,
    account: 'dcinside'
  },
  // {
  //   id: 'fmkorea',
  //   label: 'FM코리아',
  //   icon: 'F',
  //   color: '#3B5998',
  //   default: true,
  //   login: 'fmkorea'
  // },
  {
    id: 'theqoo',
    label: 'TheQoo',
    icon: 'T',
    color: '#FF9900',
    site: 'theqoo.net',
    author: '더쿠',
    default: true,
  },
  {
    id: 'ppomppu',
    label: '뽐뿌',
    icon: 'P',
    color: '#FF6B00',
    default: true
  },
  {
    id: 'ruliweb',
    label: '루리웹',
    icon: 'R',
    color: '#1185D1',
    site: 'ruliweb.com',
    author: '루리웹',
    default: true
  },
  {
    id: 'naverkin',
    label: 'N.Kin',
    icon: 'N',
    color: '#03C75A',
    default: false,
    account: 'naver'
  },
  {
    id: 'navercafe',
    label: 'N.Cafe',
    icon: 'N',
    color: '#03C75A',
    default: false,
    account: 'naver'
  },
  {
    id: 'naverblog',
    label: 'N.Blog',
    icon: 'N',
    color: '#03C75A',
    default: false,
    account: 'naver'
  },
  {
    id: 'atcosme',
    label: '@cosme',
    icon: 'N',
    color: '#9CCC65',
    default: false,
    account: 'atcosme'
  },
  {
    id: 'lips',
    label: 'LIPS',
    icon: 'L',
    color: '#F06292',
    default: false,
    account: 'lips'
  },
];


const platforms_SNS = [
  {
    id: 'instagram',
    label: 'Instagram',
    icon: 'I',
    color: '#E1306C',
    default: true
  },
  {
    id: 'threads',
    label: 'Threads',
    icon: 'T',
    color: '#000000',
    default: true,
  },
  {
    id: 'x',
    label: 'X',
    icon: 'X',
    color: '#000000',
    default: true,
  },

  {
    id: 'youtube',
    label: 'Youtube',
    icon: 'Y',
    color: '#FF0099',
    default: false
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    icon: 'T',
    color: '#000000',
    default: false
  },
]



export default platforms;
export { platforms_SNS };